import Filter from '../Filter';

export default class FilterExact extends Filter {
  validate(item, filter) {
    Object.keys(filter).forEach((key) => {
      const { value } = filter[key];

      if (!value.length) {
        return;
      }

      if (value.includes(item[key])) {
        return;
      }

      this.addIsValid(false);
    });
  }
}
